import { Link } from "react-router-dom";
import { Container } from "@/components/common/Section";

const COLUMNS = [
  {
    title: "PLATFORMS",
    links: [
      { label: "ZenPay", to: "/platforms/zenpay", testid: "footer-zenpay" },
      { label: "Wallet Platform", to: "/platforms/wallet", testid: "footer-wallet" },
      { label: "Emulation Platform", to: "/platforms/emulation", testid: "footer-emulation" },
    ],
  },
  {
    title: "SOLUTIONS",
    links: [
      { label: "Payment Engineering", to: "/solutions#services", testid: "footer-payment-engineering" },
      { label: "Banking Infrastructure", to: "/solutions#services", testid: "footer-banking-infra" },
      { label: "Product Engineering", to: "/solutions#services", testid: "footer-product-engineering" },
      { label: "Integrations", to: "/technology", testid: "footer-integrations" },
    ],
  },
  {
    title: "COMPANY",
    links: [
      { label: "About iJeeva", to: "/company", testid: "footer-about" },
      { label: "Leadership", to: "/company#leadership", testid: "footer-leadership" },
      { label: "Careers", to: "/company#careers", testid: "footer-careers" },
      { label: "Contact", to: "/contact", testid: "footer-contact" },
    ],
  },
  {
    title: "LEGAL",
    links: [
      { label: "Privacy Policy", to: "/privacy", testid: "footer-privacy" },
      { label: "Terms of Use", to: "/terms", testid: "footer-terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1D305B] text-white">
      <Container className="py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Link to="/" data-testid="footer-logo" aria-label="iJeeva home">
              <img src="/logo-white.png" alt="iJeeva" className="h-9 w-auto" />
            </Link>
            <p className="mt-5 max-w-xs text-[15px] leading-relaxed text-[#94A3B8]">
              Payments technology. Built for scale.
            </p>
            <p className="mt-4 text-sm leading-relaxed text-[#64748B]">
              Secure, scalable payment platforms and financial technology infrastructure for businesses, fintechs and
              financial institutions.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-4 lg:col-span-8">
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#64748B]">{col.title}</h3>
                <ul className="mt-5 space-y-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        data-testid={link.testid}
                        className="text-[14.5px] text-[#94A3B8] transition-colors duration-200 hover:text-white"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-5 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-[#64748B]">
            © Copyright 2026 - IJeeva Software Solutions Private Limited | All Rights Reserved
          </p>
          <div className="flex flex-wrap items-center gap-6">
            <img data-testid="footer-pci-badge" src="/pci-ssc-white.png" alt="PCI Security Standards Council" className="h-8 w-auto" />
            <p className="text-sm text-[#64748B]">Bengaluru, India</p>
          </div>
        </div>
      </Container>
    </footer>
  );
}
